import { initializeApp, type FirebaseApp } from 'firebase/app'
import {
  getAnalytics,
  isSupported,
  type Analytics,
} from 'firebase/analytics'

let app: FirebaseApp | null = null
let analytics: Analytics | null = null
let initPromise: Promise<Analytics | null> | null = null

function getFirebaseConfig() {
  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY
  const appId = import.meta.env.VITE_FIREBASE_APP_ID
  const measurementId = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID

  if (!apiKey || !appId || !measurementId) {
    return null
  }

  return {
    apiKey,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId,
    measurementId,
  }
}

export function isFirebaseAnalyticsConfigured(): boolean {
  return getFirebaseConfig() !== null
}

export async function initFirebaseAnalytics(): Promise<Analytics | null> {
  if (typeof window === 'undefined') {
    return null
  }

  if (analytics) {
    return analytics
  }

  if (initPromise) {
    return initPromise
  }

  const config = getFirebaseConfig()
  if (!config) {
    return null
  }

  initPromise = (async () => {
    const supported = await isSupported()
    if (!supported) {
      return null
    }

    app = initializeApp(config)
    analytics = getAnalytics(app)
    return analytics
  })()

  return initPromise
}

export async function getFirebaseAnalytics(): Promise<Analytics | null> {
  return analytics ?? initFirebaseAnalytics()
}
